import { ConfigMap, RolePermission } from "@core/types";

export const DEVICE_CONFIG_LAYOUT: ConfigMap = {
    defaultConfig: [
        {
            title: "Interface",
            items: [
                "Internet",
                "LAN",
                "PCI Lock",
                "IPv6 464XLAT"
            ],
            permissionId: RolePermission.CONFIG_INTERFACE
        },
        {
            title: "Dual WAN",
            items: [
                "General Settings",
                "Outbound Load Balance",
                "Protocol Binding"
            ],
            permissionId: RolePermission.CONFIG_DUAL_WAN
        },
        {
            title: "Wi-Fi",
            items: [
                "Wireless 2.4G",
                "Wireless 5G"
            ],
            permissionId: RolePermission.CONFIG_WIFI
        },
        {
            title: "Advanced Setup",
            items: [
                "Firewall",
                "Routing",
                "IPv6 Routing",
                "OSPF",
                "BGP",
                "NAT",
                "VRRP",
                "Static DNS",
                "QoS",
                "Serial Port 1",
                "Serial Port 2",
                "RGOOSE",
                "PTP",
                "CBSD",
                "Speed Test Server",
                "GPS Tracking"
            ],
            permissionId: RolePermission.CONFIG_ADVANCED_SETUP
        },
        {
            title: "VPN",
            items: [
                "IPSec",
                "PPTP Server",
                "PPTP Client",
                "L2TP",
                "GRE",
                "EoIP",
                "OpenVPN Server",
                "OpenVPN Client"
            ],
            permissionId: RolePermission.CONFIG_VPN
        },
        {
            title: "Access Management",
            items: [
                "Device Management",
                "SNMP",
                "Syslog",
                "Universal Plug and Play",
                "Dynamic DNS",
                "Access Control",
                "Packet Filter",
                "CWMP (TR-069)",
                "Parental Control",
                "BECentral"
            ],
            permissionId: RolePermission.CONFIG_ACCESS_MANAGEMENT
        },
        {
            title: "Maintenance",
            items: [
                "User Management",
                "Time Zone",
                /* "License",
                "Ignition Sensing", */
                "Auto Reboot"
            ],
            permissionId: RolePermission.CONFIG_MAINTENANCE
        },
        {
            title: "LTE TTL and HL",
            items: [
                "LTE TTL and HL"
            ],
            permissionId: RolePermission.CONFIG_ADVANCED_SETUP
        }
    ],
    wzlrulConfig: [
        {
            title: "LAN",
            items: [
                "Ethernet",
                "Wireless"
            ]
        },
        {
            title: "WAN",
            items: ["WAN"]
        }
    ],
    _8920Config: [
        {
            title: "Wi-Fi Setting",
            items: ["Wi-Fi Setting"]
        },
        {
            title: "LAN DNS",
            items: ["LAN DNS"]
        },
        {
            title: "WAN DNS",
            items: ["WAN DNS"]
        }
    ],
    openWrtConfig: [
        {
            title: "Interface",
            items: [
                "Internet",
                "LAN",
                "Band Selections"
            ],
            permissionId: RolePermission.CONFIG_INTERFACE
        },
        {
            title: "Wi-Fi",
            items: [
                "Wireless 2.4G",
                "Wireless 5G"
            ],
            permissionId: RolePermission.CONFIG_WIFI
        },
        {
            title: "Advanced Setup",
            items: [
                "WAN Usage",
                "Speed Test Server"
            ],
            permissionId: RolePermission.CONFIG_ADVANCED_SETUP
        },
        {
            title: "Access Management",
            items: [
                "CWMP (TR-069)",
                "BECentral"
            ],
            permissionId: RolePermission.CONFIG_ACCESS_MANAGEMENT
        },
        {
            title: "Maintenance",
            items: [
                "User Management",
                "Time Zone",
                "Auto Reboot"
            ],
            permissionId: RolePermission.CONFIG_MAINTENANCE
        },
        {
            title: "LTE TTL",
            items: [
                "LTE TTL"
            ],
            permissionId: RolePermission.CONFIG_ADVANCED_SETUP
        }
    ]
};